import React from "react";
import { Select, Typography, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import { RowLayout } from "../../util/accordianStyles";
import useSillFinishSelector from "./useSillFinishSelector";

const Layout = styled("div")(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

const SillFinish: React.FC = () => {
  const { handleChange, sillFinish } = useSillFinishSelector();

  return (
    <Layout>
      <Typography style={{ margin: "auto" }} variant="subtitle1">
        Sill Dam Finish
        <span style={{ color: "red", fontSize: 20 }}>*</span>
      </Typography>
      <RowLayout>
        <Select
          value={sillFinish}
          onChange={handleChange}
          style={{ backgroundColor: "white" }}
          label="finish"
          variant="outlined"
          margin="dense"
          size="small"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value="No Finish">No Finish</MenuItem>
          <MenuItem value="Match Interor Finish">
            Match Interior Finish
          </MenuItem>
        </Select>
      </RowLayout>
    </Layout>
  );
};

export default SillFinish;
